export const isPropertyFrozen = (property, frozenStatus, frozenProperties) => {
  if (frozenStatus && Array.isArray(frozenProperties)) {
    return frozenProperties.includes(property)
  }
}
